import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useMutation, type UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { type AxiosResponse } from 'axios';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { MUTATION_KEYS, QUERY_KEYS } from 'constants/common';
import { AppointmentService } from 'services/appointments';
import { type AppointmentRatingPayload } from 'types/appointments';

export const useRateAppointment = (): UseMutationResult<
  AxiosResponse<AppointmentRatingPayload>,
  Error,
  AppointmentRatingPayload
> => {
  const queryClient = useQueryClient();
  const { t } = useTranslation(LOCIZE_NS.APPOINTMENTS);
  return useMutation({
    mutationKey: [MUTATION_KEYS.RATE_APPOINTMENT],
    mutationFn: (body: AppointmentRatingPayload) => AppointmentService.sendAppointmentRating(body),
    onSuccess: () => {
      toast.success(t('RateAppointment.success'));
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.FETCH_NEXT_APPOINTMENTS] });
    },
    onError: () => {
      toast.error(t('RateAppointment.error'));
    },
  });
};
